__turbopack_context__.v({
  "burst": "BookmarkButton-module-scss-module___GuD4a__burst",
  "pop": "BookmarkButton-module-scss-module___GuD4a__pop",
});
